import useStableState from 'utils/useStableState'

export function useIsBannerShowing() {
    return useStableState('IsAppBannerShowing')
}
